import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { SettlementTicketAttachmentMode } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { SettlementTicketAttachmentOptions } from '~hooks/useSettlements/models';
import isEnumValue from '~utils/isEnumValue';

const ticketAttachmentModeLabelKeys = {
  [SettlementTicketAttachmentMode.MERGED]:
    'approvals.driver_pay.settlements.email_settlement.ticket_modes.merged',
  [SettlementTicketAttachmentMode.SEPARATE_PDF]:
    'approvals.driver_pay.settlements.email_settlement.ticket_modes.separate_pdf',
  [SettlementTicketAttachmentMode.ZIP]:
    'approvals.driver_pay.settlements.email_settlement.ticket_modes.zip',
} satisfies Record<SettlementTicketAttachmentMode, string>;

interface TicketAttachmentOptionsProps {
  isDisabled: boolean;
  onChange: (options: SettlementTicketAttachmentOptions) => void;
  value: SettlementTicketAttachmentOptions;
}

export default function TicketAttachmentOptions({
  isDisabled,
  onChange,
  value,
}: TicketAttachmentOptionsProps) {
  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={value.attachTickets}
            onChange={(event) =>
              onChange({ ...value, attachTickets: event.target.checked })
            }
          />
        }
        disabled={isDisabled}
        label={t('approvals.driver_pay.settlements.email_settlement.attach_tickets')}
      />
      {value.attachTickets && (
        <Select
          disabled={isDisabled}
          SelectDisplayProps={{
            'aria-label': t(
              'approvals.driver_pay.settlements.email_settlement.ticket_attachment_mode',
            ),
          }}
          onChange={(event) => {
            if (isEnumValue(SettlementTicketAttachmentMode, event.target.value)) {
              onChange({ ...value, ticketAttachmentMode: event.target.value });
            }
          }}
          size="small"
          value={value.ticketAttachmentMode}
        >
          {Object.entries(ticketAttachmentModeLabelKeys).map(([mode, labelKey]) => (
            <MenuItem key={mode} value={mode}>
              {t(labelKey)}
            </MenuItem>
          ))}
        </Select>
      )}
    </Box>
  );
}
